// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I4vx3","tabsBox":"styles_tabsBox__2VBQC","createButton":"styles_createButton__1pRJQ"};